import React from 'react';
import { Box, Card, CardContent, Typography, IconButton } from '@mui/material';
import { Factory as FactoryIcon, Delete as DeleteIcon } from '@mui/icons-material';

interface PlantGridProps {
  plants: any[];
  onPlantClick: (plant: any) => void;
  onPlantDelete: (plantId: string, event: React.MouseEvent) => void;
}

const PlantGrid: React.FC<PlantGridProps> = ({ plants, onPlantClick, onPlantDelete }) => {
  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(180px, 1fr))',
        gap: 2.5,
      }}
    >
      {plants?.map((plant: any) => (
        <Card
          key={plant.id}
          onClick={() => onPlantClick(plant)}
          sx={{
            cursor: 'pointer',
            transition: 'all 0.2s ease-in-out',
            backgroundColor: 'white',
            border: '1px solid #e0e0e0',
            borderRadius: '8px',
            boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
            minHeight: 120,
            display: 'flex',
            alignItems: 'center',
            position: 'relative',
            '& .delete-button': {
              opacity: 1,
            },
            '&:hover': {
              boxShadow: '0 4px 8px rgba(0,0,0,0.15)',
              transform: 'translateY(-2px)',
              borderColor: '#1976d2',

            },
          }}
        >
          <IconButton
            className="delete-button"
            onClick={(e) => onPlantDelete(plant.id, e)}
            sx={{
              position: 'absolute',
              top: 4,
              right: 4,
              padding: '4px',
              opacity: 0,
              transition: 'opacity 0.2s ease-in-out',
              backgroundColor: 'rgba(255, 255, 255, 0.9)',
              '&:hover': {
                backgroundColor: '#ffebee',
                '& .MuiSvgIcon-root': {
                  color: '#d32f2f',
                },
              },
            }}
          >
            <DeleteIcon sx={{ fontSize: 18, color: '#666' }} />
          </IconButton>
          <CardContent
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              p: 2.5,
              width: '100%',
              '&:last-child': {
                pb: 2.5,
              },
            }}
          >
            <FactoryIcon
              sx={{
                fontSize: 32,
                color: '#1976d2',
                bgcolor: '#e6eefe',
                mb: 1.5,
                opacity: 0.8,
                p: 0.5
              }}
            />
            <Typography
              variant="caption"
              sx={{
                color: '#666',
                fontSize: 10,
                mb: 0.5,
                fontWeight: 500,
                letterSpacing: '0.5px',
                lineHeight: 1.2,
                textAlign: 'center'
              }}
            >
              PLANT
            </Typography>
            <Typography
              variant="h6"
              sx={{
                fontWeight: 600,
                color: '#333',
                fontSize: '1rem',
                lineHeight: 1.3,
                textAlign: 'center',
                wordBreak: 'break-word',
                width: '100%'
              }}
            >
              {plant.name}
            </Typography>
          </CardContent>
        </Card>
      ))}
    </Box>
  );
};

export default PlantGrid;